import './styles.css';

import cn from 'classnames';
import {twMerge} from 'tailwind-merge';

export const CircleLoader = ({className}) => {
    return (
        <div className={twMerge(cn('lds-roller', className))}>
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};
